import React from 'react';
import { Outlet } from 'react-router-dom';
import NavBar from '../NavBar';
import PortfolioRebalanceJobWatcher from '../PortfolioRebalance/PortfolioRebalanceJobWatcher';

const Layout = () => {

  return (
    <>
      <NavBar />
      {/* Global watcher for the async rebalance flow (WS + poll + notification) */}
      <PortfolioRebalanceJobWatcher />
        <main>
            <Outlet />
        </main>
      {/* <Footer /> */}
    </>
  );
};

export default Layout;
